import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SEO from "../seo";
import { slugify } from "../../utils/slugify";

const LandingPageSetup = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  // Icon mapping function based on section title
  const getSectionIcon = (title) => {
    const iconMap = {
      "Create Your Account and Landing Page": (
        <svg
          width="40"
          height="40"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M39.75 13.25H13.25C8.38163 13.25 4.41663 17.215 4.41663 22.0833V39.75C4.41663 44.6184 8.38163 48.5833 13.25 48.5833H39.75C44.6184 48.5833 48.5833 44.6184 48.5833 39.75V22.0833C48.5833 17.215 44.6184 13.25 39.75 13.25Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 13.25V9.9375C19.875 7.40167 21.9017 5.375 24.4375 5.375H28.5625C31.0983 5.375 33.125 7.40167 33.125 9.9375V13.25"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 23.1875H33.125"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 30.9166H33.125"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      "Complete Your xPage Store Information": (
        <svg
          width="40"
          height="40"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.5 48.5833C38.6962 48.5833 48.5833 38.6962 48.5833 26.5C48.5833 14.3037 38.6962 4.41663 26.5 4.41663C14.3037 4.41663 4.41663 14.3037 4.41663 26.5C4.41663 38.6962 14.3037 48.5833 26.5 48.5833Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.5 17.6666V26.5L31.9375 31.9375"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.6666 26.5H35.3333"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      "Add Staff and Set Permissions": (
        <svg
          width="40"
          height="40"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M39.75 17.6666H13.25C8.38163 17.6666 4.41663 21.6316 4.41663 26.5V39.75C4.41663 44.6184 8.38163 48.5833 13.25 48.5833H39.75C44.6184 48.5833 48.5833 44.6184 48.5833 39.75V26.5C48.5833 21.6316 44.6184 17.6666 39.75 17.6666Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.6666 17.6666V13.25C17.6666 9.00996 21.0933 5.58329 25.3333 5.58329H27.6666C31.9066 5.58329 35.3333 9.00996 35.3333 13.25V17.6666"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.5 35.3333C29.8135 35.3333 32.5 32.6468 32.5 29.3333C32.5 26.0198 29.8135 23.3333 26.5 23.3333C23.1865 23.3333 20.5 26.0198 20.5 29.3333C20.5 32.6468 23.1865 35.3333 26.5 35.3333Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      "Set Up Your Domain": (
        <svg
          width="40"
          height="40"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.5 48.5833C38.6962 48.5833 48.5833 38.6962 48.5833 26.5C48.5833 14.3037 38.6962 4.41663 26.5 4.41663C14.3037 4.41663 4.41663 14.3037 4.41663 26.5C4.41663 38.6962 14.3037 48.5833 26.5 48.5833Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.41663 26.5H48.5833"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.5 4.41663C32.2291 9.26083 35.3333 17.4796 35.3333 26.5C35.3333 35.5204 32.2291 43.7392 26.5 48.5833C20.7708 43.7392 17.6666 35.5204 17.6666 26.5C17.6666 17.4796 20.7708 9.26083 26.5 4.41663Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      "Add Your Products": (
        <svg
          width="40"
          height="40"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M39.75 17.6666H13.25C8.38163 17.6666 4.41663 21.6316 4.41663 26.5V39.75C4.41663 44.6184 8.38163 48.5833 13.25 48.5833H39.75C44.6184 48.5833 48.5833 44.6184 48.5833 39.75V26.5C48.5833 21.6316 44.6184 17.6666 39.75 17.6666Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.41663 22.0833H48.5833"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M33.125 35.3333C35.1012 35.3333 36.7083 33.7262 36.7083 31.75C36.7083 29.7738 35.1012 28.1666 33.125 28.1666C31.1488 28.1666 29.5416 29.7738 29.5416 31.75C29.5416 33.7262 31.1488 35.3333 33.125 35.3333Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    };

    return (
      iconMap[title] || (
        <svg
          width="40"
          height="40"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.5 48.5833C38.6962 48.5833 48.5833 38.6962 48.5833 26.5C48.5833 14.3037 38.6962 4.41663 26.5 4.41663C14.3037 4.41663 4.41663 14.3037 4.41663 26.5C4.41663 38.6962 14.3037 48.5833 26.5 48.5833Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.5 17.6666V26.5L31.9375 31.9375"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
    );
  };

  const helpSections = [
    {
      title: "Landing Page Setup",
      description:
        "Configure and optimize your landing page for maximum conversion",
      items: [
        {
          id: "landing-page-setup",
          title: "Landing Page Setup",
          description: "Complete guide to setting up your xPage landing page.",
          icon: (
            <svg
              width="40"
              height="40"
              viewBox="0 0 53 53"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M39.75 4.41663H13.25C8.38163 4.41663 4.41663 8.38163 4.41663 13.25V39.75C4.41663 44.6184 8.38163 48.5833 13.25 48.5833H39.75C44.6184 48.5833 48.5833 44.6184 48.5833 39.75V13.25C48.5833 8.38163 44.6184 4.41663 39.75 4.41663Z"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M19.875 19.875H33.125"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M19.875 28.7083H33.125"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M19.875 37.5416H26.5"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ),
          sections: [
            {
              id: "Create Your Account and Landing Page",
              title: "Create Your Account and Landing Page",
              description:
                "Set up your xPage account and create your first landing page.",
            },
            {
              id: "Complete Your xPage Store Information",
              title: "Complete Your xPage Store Information",
              description:
                "Fill in your store details, business information, and contact details.",
            },
            {
              id: "Add Staff and Set Permissions",
              title: "Add Staff and Set Permissions",
              description:
                "Invite team members and configure their access levels and permissions.",
            },
            {
              id: "Set Up Your Domain",
              title: "Set Up Your Domain",
              description:
                "Connect your custom domain or use xPage subdomain for your store.",
            },
            {
              id: "Add Your Products",
              title: "Add Your Products",
              description:
                "Upload products, set pricing, and organize your product catalog.",
            },
          ],
        },
      ],
    },
  ];

  // Handle card click - update URL with section like sidebar (no slugs)
const handleCardClick = (itemId, sectionId) => {
  navigate(`/help/${slugify(itemId)}/${slugify(sectionId)}`);
};

  // Filter items based on search query
  const filteredSections = helpSections
    .map((section) => ({
      ...section,
      items: section.items.filter(
        (item) =>
          item.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
          section.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.sections.some(
            (sectionItem) =>
              sectionItem.title
                .toLowerCase()
                .includes(searchQuery.toLowerCase()) ||
              sectionItem.description
                .toLowerCase()
                .includes(searchQuery.toLowerCase()),
          ),
      ),
    }))
    .filter((section) => section.items.length > 0);

  return (
    <div className="min-h-screen  flex flex-col md:pt-10 pt-16">
      <SEO
        title="Landing Page Setup – xPAGE Help Center"
        description="Learn how to set up your xPage landing page from start to finish. Create your account, add store information, connect your domain, and publish your first page in minutes."
        keywords="xPAGE, landing page setup, create landing page, online store setup, xPage domain, eCommerce store, AI builder"
        canonical="https://help.xpage.ai/help/landing-page-setup/landing-page-setup"
        type="article"
      />

      <div className="flex-1 w-full py-6 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Header with Description */}
          <div className="mb-6">
            <h1 className="text-2xl font-semibold text-systemTitle mb-3">
              Landing Page Setup
            </h1>

            {/* Added description text */}
            <div className="mb-6">
              <p className="text-sm text-systemSubTitle leading-relaxed">
                Get your landing page live in minutes with xPage. Sign up with
                your email, set a secure password, and instantly start building
                your page. Add your landing page name, contact info, business
                address, time zone, currency, and brand identity. Import
                products from AliExpress, Amazon, or your own catalog, or create
                products manually with images, descriptions, and AI-generated
                copy. xPage automatically provides a free xpage.ai domain for
                your page, or you can connect your own custom domain for a fully
                branded experience. With everything set, your landing page is
                ready to showcase your products and start converting visitors
                into customers.
              </p>
            </div>
          </div>

          {/* Spacing between description and cards */}
          <div className="mb-6"></div>

          {/* Help Sections */}
          <div className="space-y-6">
            {filteredSections.map((section, sectionIndex) => (
              <div className="p-4">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {section.items.flatMap((item) =>
                    item.sections.map((sectionItem, sectionIndex) => (
                      <div
                        key={sectionIndex}
                        onClick={() => handleCardClick(item.id, sectionItem.id)}
                        className="group relative bg-white border border-gray-200 rounded-xl p-4 hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1 cursor-pointer hover:border-systemLabel"
                      >
                        {/* Hover effect background */}

                        <div className="relative z-10">
                          {/* Icon and Title */}
                          <div className="flex items-center space-x-3 mb-3">
                            <div className="flex-shrink-0 w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center transition-colors duration-300 group-hover:bg-deepPurple/5">
                              {getSectionIcon(sectionItem.title)}
                            </div>
                            <h3 className="text-lg font-semibold text-systemTitle transition duration-300">
                              {sectionItem.title}
                            </h3>
                          </div>

                          {/* Section-specific description */}
                          <p className="text-sm text-systemLabel leading-relaxed transition-colors duration-300">
                            {sectionItem.description}
                          </p>

                          {/* Hover arrow indicator */}
                          <div className="absolute right-3 top-3 opacity-0 group-hover:opacity-100 transform translate-x-2 group-hover:translate-x-0 transition-all duration-300">
                            <svg
                              className="w-7 h-7 text-base"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 5l7 7-7 7"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    )),
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPageSetup;
